module.exports = __webpack_public_path__ + "img/IMG-20200316-WA0030.78ea9d4a.jpg";